import {makeRoute} from '$src/lib/helper';

export default {
    routes: [{
        path: '/application/:id_user',
        meta: {isAuth: true, hasRight: 'access_application', action: 'application/fetch'},
        component: () => import(/* webpackChunkName: "application" */ '$application/layouts/ApplicationLayout'),
        children: [
            makeRoute('', 'application_overview', () => import(/* webpackChunkName: "application" */ '$application/views/ApplicationView')),

            makeRoute('step/:id_application_step', 'application_step', () => import(/* webpackChunkName: "application" */ '$application/views/ApplicationStepView')),

            makeRoute('step/:id_application_step/item/:id_property', 'application_item', () => import(/* webpackChunkName: "application" */ '$application/views/ApplicationItemView')),

            makeRoute('welcome', 'application_welcome', () => import(/* webpackChunkName: "application" */ '$application/views/ApplicationWelcomeView'), {
                hasRole: 'applicant',
            }),

            makeRoute('more-information', 'application_information', () => import(/* webpackChunkName: "application" */ '$application/views/ApplicationInformationView')),

            makeRoute('agreement', 'application_agreement', () => import(/* webpackChunkName: "application" */ '$application/views/ApplicationAgreementView'), {
                hasRole: 'applicant',
            }),

            makeRoute('complete', 'application_complete', () => import(/* webpackChunkName: "application" */ '$application/views/ApplicationCompleteView'), {
                hasRole: 'applicant',
            }),
        ],
    }, {
        path: '/application/:id_user/itb',
        meta: {isAuth: true, action: 'application/fetch'},
        name: 'application_step_itb',
        component: () => import(/* webpackChunkName: "application" */ '$application/views/IonaFrameView'),
    }],

    hooks: {
        async initialize() {
            await Promise.all([
                import(/* webpackChunkName: "application" */ '$application/modals'),
                import(/* webpackChunkName: "application" */ '$application/components'),
                import(/* webpackChunkName: "application" */ '$src/components/form'),
                import(/* webpackChunkName: "application" */ '$application/modules'),
            ]);
        },

        beforeEnter() {
            this.$ui.titleTemplate = '%s - START Bewerbung';
            this.$ui.defaultTitle = 'START Stiftung Bewerbung';
        },
    },
};